import { GQLDesignPageFragment } from '@theprintbar/graphql';
import { useCallback, useEffect, useState } from 'react';
import { PrimaryButton } from '../../Button';
import { Checkbox } from '../../FormFields';
import { Modal } from '../../Modal';
import { RichText } from '../../RichText';

interface UploadDisclaimerProps {
	hasUploaded: boolean;
	content: GQLDesignPageFragment;
}

function setWaiverInStorage() {
	localStorage.setItem('waiverAccepted', 'true');
}

function hasAlreadyAccept() {
	return !!localStorage.getItem('waiverAccepted');
}

export function UploadDisclaimer({ hasUploaded, content }: UploadDisclaimerProps) {
	const [showWaiver, setShowWaiver] = useState(false);
	const [hasAccepted, setHasAccepted] = useState(false);

	useEffect(() => {
		if (hasUploaded && !hasAlreadyAccept()) {
			setShowWaiver(true);
		}
	}, [hasUploaded]);

	const handleUplaodWaiver = useCallback(() => {
		setWaiverInStorage();
		setShowWaiver(false);
	}, []);

	return (
		<Modal title="Upload Waiver" open={showWaiver} className="min-h-0 max-w-xl">
			<div className="flex flex-col h-full space-between p-4">
				<RichText content={content.uploadWaiver} />
				<Checkbox
					className="mt-8"
					name="waiver"
					outsideForm
					label={content.uploadWaiverCheckboxText}
					onChange={v => setHasAccepted(v.currentTarget.checked)}
				/>
				<PrimaryButton disabled={!hasAccepted} onClick={handleUplaodWaiver} className="w-full">
					Continue
				</PrimaryButton>
			</div>
		</Modal>
	);
}
